// FLAGS: none
// Presentational check-in row: formats a theme's score, date and trend from data it is handed.
import { ResponseVitalityCheckinVitalityCheckinModuleScoreResponse } from "@src/api/v1/data-contracts";
import { formatFirstUpperCase, formatScore } from "@src/utils/formatter";
import CustomTitleCell from "@src/components/table/CustomTitleCell";
import { getScoreColorClass } from "@src/utils/scoreColourClass";
import { TableRow, TableRowData } from "./table/TableRow";

interface ClientCheckinsOverviewTableProps {
  question: ResponseVitalityCheckinVitalityCheckinModuleScoreResponse;
  message: string;
  getCorrectDate: (date: string) => string;
  index: number;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  onClick?: () => void;
  hideArrow?: boolean;
  isMedical?: boolean;
}

const ClientCheckinsOverviewTable = ({
  question,
  message,
  getCorrectDate,
  index,
  open,
  setOpen,
  onClick,
  hideArrow = false,
  isMedical = false,
}: ClientCheckinsOverviewTableProps) => {
  const shouldRenderData = open || index === 0;

  const getProgressIcon = (): string => {
    if (question.progressPercent == null) {
      return "unfold_less";
    }
    if (question.progressPercent > 0) {
      return "keyboard_arrow_up";
    }
    return "keyboard_arrow_down";
  };

  const buildRowData = (): TableRowData[] => {
    const themeCell = { value: formatFirstUpperCase(question.themeKey) };

    if (!question.key) {
      return [themeCell, ...new Array(3).fill({ value: "N/A" })];
    }

    return [
      themeCell,
      {
        value: formatScore(question.score),
        colorClass: getScoreColorClass(question.score),
      },
      { value: getCorrectDate(question.createdAt) },
      { iconValue: getProgressIcon() },
    ];
  };

  return (
    <tr
      tabIndex={-1}
      data-testid={`fill-cell-${question.themeKey}`}
      onClick={onClick}
      className={`${question.key ? "cursor-pointer" : ""}`}
    >
      <CustomTitleCell
        text={message}
        emptyCell={index !== 0}
        open={open}
        setOpen={setOpen}
        hideExpandableButton={hideArrow}
        hideTitle={isMedical}
      />
      {shouldRenderData && <TableRow rowData={buildRowData()} />}
    </tr>
  );
};

export default ClientCheckinsOverviewTable;
